document.addEventListener("DOMContentLoaded", () => {

  // ─── Mobile menu ─────────────────────────────────────────────────────────
  const burger = document.querySelector(".js-burger");
  const menu   = document.querySelector(".js-header-nav");
  if (burger && menu) {
    burger.addEventListener("click", () => {
      const open = menu.classList.toggle("active");
      burger.classList.toggle("active", open);
      document.body.classList.toggle("locked", open);
    });
    window.addEventListener("resize", () => {
      if (window.innerWidth > 992) {
        menu.classList.remove("active");
        burger.classList.remove("active");
        document.body.classList.remove("locked");
      }
    });
  }

  // ─── Search overlay ───────────────────────────────────────────────────────
  const openSearchBtn  = document.querySelector(".js-open-search");
  const closeSearchBtn = document.querySelector(".js-close-search");
  const searchOverlay  = document.querySelector(".js-search-overlay");
  if (openSearchBtn && closeSearchBtn && searchOverlay) {
    openSearchBtn.addEventListener("click", (e) => {
      e.preventDefault();
      searchOverlay.classList.add("active");
      document.body.classList.add("locked");
      setTimeout(() => {
        const input = searchOverlay.querySelector("input");
        if (input) input.focus();
      }, 100);
    });
    closeSearchBtn.addEventListener("click", () => {
      searchOverlay.classList.remove("active");
      document.body.classList.remove("locked");
    });
    searchOverlay.addEventListener("click", (e) => {
      if (e.target === searchOverlay) {
        searchOverlay.classList.remove("active");
        document.body.classList.remove("locked");
      }
    });
  }

  // ─── FAQ accordion ─────────────────────────────────────────────────────────
  document.querySelectorAll(".js-faq-item").forEach((item) => {
    const trigger = item.querySelector(".js-faq-trigger");
    if (!trigger) return;
    trigger.addEventListener("click", () => {
      const open = !item.classList.contains("is-open");
      item.classList.toggle("is-open", open);
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  // ─── Back to top ─────────────────────────────────────────────────────────
  const backToTop = document.querySelector(".js-back-to-top");
  if (backToTop) {
    const toggle = () => backToTop.classList.toggle("is-visible", window.scrollY > 400);
    window.addEventListener("scroll", toggle, { passive: true });
    toggle();
    backToTop.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  // ─── Scroll reveal — hero/about/newsletter content (see .js-reveal in ────
  // _hero.scss). Content is visible by default; this only ADDS a hidden
  // class before removing it once in view, so a slow/failed script load
  // never hides page content. Skipped entirely for prefers-reduced-motion.
  const revealTargets = document.querySelectorAll(".js-reveal");
  if (revealTargets.length && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.remove("is-hidden");
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      revealTargets.forEach((el) => {
        el.classList.add("is-hidden");
        observer.observe(el);
      });
    }
  }

  // ─── Category 2 horizontal slider arrows ──────────────────────────────────
  // Native overflow-x scroll-snap already gives touch/drag on mobile and
  // desktop; these arrows just nudge that same scroll position — no
  // slider library added (see docs/assets.md).
  document.querySelectorAll(".cat-slider").forEach((slider) => {
    const track = slider.querySelector(".js-slider-track");
    const prev = slider.querySelector(".js-slider-prev");
    const next = slider.querySelector(".js-slider-next");
    if (!track) return;

    const scrollByCard = (direction) => {
      const card = track.querySelector(".health-card");
      const amount = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
      track.scrollBy({ left: amount * direction, behavior: "smooth" });
    };

    if (prev) prev.addEventListener("click", () => scrollByCard(-1));
    if (next) next.addEventListener("click", () => scrollByCard(1));
  });

});
